<template>

  <div>
    <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus" @click="addMaterial">添加素材</el-button></div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="material_id" label="素材ID" width="60"></el-table-column>
        <el-table-column  label="发布人名称" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.user_id">{{scope.row.user.nickName}}</div>
              <div v-else>{{scope.row.nickName}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="address" label="发布人头像" width="100">
          <template slot-scope="scope">
            <img v-if="scope.row.user_id" v-img-url="scope.row.user.avatarUrl" width="30" height="30" />
            <img v-else v-img-url="scope.row.avatar.file_path" width="30" height="30" />
          </template>
        </el-table-column>
        <el-table-column prop="material_title" label="分享内容" >
          <template slot-scope="scope">
            <div class="text-ellipsis" :title="scope.row.material_title">{{scope.row.material_title}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="category.name" label="关联产品" width="200">
          <template slot-scope="scope">
              <div class="product-info" v-if="scope.row.product">
                <div class="pic"><img v-img-url="scope.row.product.image[0].file_path" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product.product_name }}</div>
                  <div class="price">￥{{ scope.row.product.product_price }}</div>
                  <div class="name">ID：{{ scope.row.product.product_id }}</div>
                </div>
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="virtual_views" label="虚拟阅读量" width="100"></el-table-column>
        
        <el-table-column prop="material_sort" label="素材排序" width="100"></el-table-column>
        <el-table-column prop="material_status" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.material_status == 1" class="green">显示</span>
            <span v-if="scope.row.material_status == 0" class="gray">隐藏</span>
          </template>
        </el-table-column>

        <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="140"></el-table-column>
        <el-table-column prop="name" label="操作" width="90">
          <template slot-scope="scope">
            <el-button @click="editMaterial(scope.row)" type="text" size="small">编辑</el-button>

            <el-button @click="deleteMaterial(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialApi from '@/api/material.js';
export default {
  components: {},
  data() {
    return {
      /*分类*/
      categoryData: [],
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      commentData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1
    };
  },
  created() {
    /*获取素材列表*/
    this.getTableList();
  },
  methods: {

    /*获取素材列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      MaterialApi.materialList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*添加素材*/
    addMaterial() {
      this.$router.push({
        path: '/plus/material/material/Add'
      });
    },

    /*编辑素材*/
    editMaterial(row) {
      let params = row.material_id;
      this.$router.push({
        path: '/plus/material/material/Edit',
        query: {
          material_id: params
        }
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getTableList();
    },

    /*删除素材*/
    deleteMaterial(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          MaterialApi.materialDel(
            {
              material_id: row.material_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },



    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/material/material/Index.vue